

import { lighten } from '@material-ui/core/styles/colorManipulator';
export const styles = theme => ({
   root: {
        marginTop: theme.spacing(3),
        position: 'relative',
        // paddingTop: theme.spacing(2),
        // paddingBottom: theme.spacing(2),
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    buttonActive: {
        color: '#fff',
        backgroundColor: '#007bff',
        // borderRight: 'none',
        border: 'none',
        borderRadius: 'unset', 
    },
    buttonNonActive: {
        // borderRight: 'none',
        border: 'none',
        borderRadius: 'unset', 
    },
    containerButton: {
        display: 'flex', 
        marginLeft: '1rem'
    }
})

export const toolbarStyles = theme => ({
    selectType: {
        textTransform: 'capitalize',
    },
    selected: {
        '&:focus': {
          backgroundColor: 'transparent',
        }
    },
    titleText: {
      fontSize: '1.11rem',
    },
    root: {
        // flexWrap: 'wrap',
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
        boxSizing: 'border-box',
        backgroundColor: 'rgba(41, 47, 72, 0.85)',
        color: '#fff',
        [theme.breakpoints.up('md')]: {
            minHeight: theme.spacing(7)
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: theme.spacing(7)
        },
    },
    box: {
        display: 'flex',
        alignItems: 'center',
        marginRight: 0,
        marginLeft: theme.spacing(3),
        width: "100%"
    },
    formControl: {
        color:'rgba(0, 0, 0, 0.87)',                                                                                                                                                                                                                                                                                                                                                                                                                             
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: '#ffffff',
        '&:hover': {
            backgroundColor: '#f4f4f4',
        },
        marginLeft: theme.spacing(2),
        marginRight: 0,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        width: '100%',
    },
    inputBase: {
        color: theme.palette.text.secondary,
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: '#f4f4f4',
        '&:hover': {
            backgroundColor: '#f4f4f4',
        },
        marginLeft: theme.spacing(2),
        marginRight: 0,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        width: '100%',
    },
    inputRoot: {
        color: 'inherit',
        minHeight: "auto",
        boxSizing: 'border-box'
    },
    inputRootSelected: {
        width: "100%",
    },
    inputInputSelected: {
        boxSizing: 'border-box',
        lineHeight: 1.75
    },
    inputInput: {
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        transition: theme.transitions.create('width'),
        width: '100%',
        fontSize: '0.8rem',
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 1),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
        textAlign: 'right',
    },
    actions: {
        color: '#fff',
        flex: '1',
        display: 'flex',
        fontSize: '0.89rem',
        justifyContent: 'space-around',
        boxSizing: 'border-box',
    },
    title: {
        flex: '0 0 auto',
        color: '#fff'
    },
});


export const emotionStyle = theme => ({
    container:{
        display: 'flex',
        padding: '2rem',
        justifyContent: 'space-between',
    }, 
    countEmotion: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'rgba(201, 203, 209, 0.25)',
        alignItems: 'center',
        height: '2rem',
        marginTop: '1rem',
        fontWeight: '500',
        fontSize: '1.5rem',
        padding: '0.4rem',
        padding: '0.8rem'
    },
    containerEmotion: { 
        flexBasis: '15%',
        margin: '1rem',
        flexDirection: 'column',
    },
    containerIconEmotion: {
        display: 'flex',
        justifyContent: 'center', 
    },
    iconEmotion: { 
        width: '5rem'
    }
})
export const chartStyle = theme => ({
    containerNote: {
        width: '50%',
        display: 'flex',
        justifyContent: 'space-between',
        margin: 'auto',
        padding: '1rem'
    },
    love: {
        width: '1rem',
        height: '1rem',
        marginRight: '0.5rem',
        backgroundColor: '#fa52d9'
    },
    happy: {
        width: '1rem',
        height: '1rem',
        marginRight: '0.5rem',
        backgroundColor: '#28a745',
    },
    normal: {
        width: '1rem',
        height: '1rem',
        marginRight: '0.5rem',
        backgroundColor: '#007bff'
    },
    sad: {
        width: '1rem',
        height: '1rem',
        marginRight: '0.5rem',
        backgroundColor: '#ffc107'
    },
    angry: {
        width: '1rem',
        height: '1rem',
        marginRight: '0.5rem',
        backgroundColor: '#dc3545'
    },
    note: {
        display: 'flex'
    }

})

export const listInteractStyle = theme => ({
    TextField: {
        minWidth: '10rem'
    },
    containerCustom: {
        marginRight: '1rem'
    },
    root: {
        marginTop: theme.spacing(3), 
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    notiTable: {
        padding: '1.5rem',
        borderBottom: 'solid 1px #dcdcdc',
    },
    formControl: { 
      minWidth: '100%',
    },
    notificationsActiveIcon: {
        color: '#ff513f',
    }, 
    iconEmotion: {
        width: '1.5rem'
    },
    emotionContainer: {
        display: 'flex',
        // justifyContent: 'center',
        alignItems: 'center'
    },
    emotionText: {
        marginLeft: '0.5rem'
    },
    love: {
        color: '#fa52d9'
    },
    happy: {
        color: '#28a745'
    },
    normal: {
        color: '#007bff'
    },
    sad: {
        color: '#ffc107'
    },
    angry: {
        color: '#dc3545'
    },
    rootCustom: {
        minHeight: '2rem'
    }
})